<template>
  <!--  <a-spin :spinning="isLoading">-->
  <div>
    <x-grid
        :id="'formList'"
        :rowId="rowId"
        :pager-config="pagerConfig"
        :form-config="formConfig"
        :url="url"
        :otherParams="{'taskType':1}"
        :columns="columns"
        :checkbox-config="checkboxConfig"
        :toolbar-config="toolbarConfig"
        :print-config="printConfig"
        :import-config="importConfig"
        :export-config="exportConfig"
        ref="grid"
        :cellClick="chooseRow"
        :cell-db-click="updateRow"
        @toolbar-addData="addRow"
    >
      <template v-slot:[toolbarConfig.templatelSlots]>
        <vxe-button @click="synchronization()">同步数据</vxe-button>
        <vxe-button @click="chooseOpenPop('checkResult')">查看群发情况</vxe-button>
      </template>
    </x-grid>

    <!--  弹出层  -->
    <popModal title="查看群发情况" :pop-config="popConfig.checkResult">
      <checkResult ref="checkResult"
                   :taskId="popConfig.checkResult.id"
                   :row="popConfig.checkResult.row"
                   :type="'checkResult'"
                   @closePop="closePopAndRefresh"
      ></checkResult>
    </popModal>

    <!--明细页表单简化通用写法-->
    <formModal title="群发客户群消息" :visible="editModalVisible">
      <detailForm :rowId="editRowId"
                  v-if="editModalVisible"
                  ref="detailForm"
                  @cancelled="closeEdit()"
                  @saved="closeEdit(true)">
      </detailForm>
    </formModal>
  </div>
  <!--  </a-spin>-->
</template>

<script>
import {
  GridMixin,
  api,
  fac,
} from "@/utils/common/XGridBase"

import detailForm from "./MassSendCustomerDetail";
import {dataApi} from "@/services/operate/MassSendCustomer";
import checkResult from "./detail/checkResult";

//列表接口
const url = api.operate.MASS_SEND_CUSTOMER;

//主键
const rowId = 'taskId';

//列
const columns = [
  // fac.makeColumnRadioDefault(),
  fac.makeColumnCheckboxDefault(),
  fac.makeColumnSeqDefault(),
  fac.makeColumn("taskTitle", "标题", 160),
  fac.makeColumn("taskContent", "内容", 300),
  fac.makeColumn("userName", "创建人", 160),
  fac.makeColumn("createDate", "创建时间", 160),
]

//筛选项
const formConfig = fac.makeFormConfig(columns, [
  {field: 'userName'},
  {field: 'createDate', type: 'dateRange'},
])

//工具栏按钮
const toolbarConfig = fac.makeToolbarConfig({
  import: false,
  export: false,
  delData: false,
  addData: true,
  templatelSlots: 'toolbarBtns'
});

//可编辑表格约束
const editRules = fac.makeEditRules(columns);
const printConfig = fac.makePrintConfig(columns);
const pagerConfig = fac.makePagerConfig();
const checkboxConfig = fac.makeCheckboxConfig(columns);
const popConfig = fac.makePopConfig(['checkResult']);

async function loadBaseData() {

}

export default {
  mixins: [GridMixin],
  components: {
    detailForm,checkResult
  },
  data() {
    return {
      columns,
      rowId,
      url,
      formConfig,
      toolbarConfig,
      printConfig,
      checkboxConfig,
      editRules,
      pagerConfig,
      popConfig,
    }
  },
  async mounted() {
    // let that = this;
    // setInterval(()=>{
    //   console.log(that.$refs['grid'].$refs['xGrid'].getFormItems())
    // },1000)
  },
  methods: {
    loadBaseData,
    async synchronization() {
      this.loading(true);
      await dataApi.synchronization().then(() => {
        this.$message.success('同步成功');
        this.refresh()
        this.loading(false);
      }).catch(() => {
        this.loading(false);
      });
    },

  }
}
</script>

<style scoped>
</style>